import React, { useState, useEffect, useRef, useLayoutEffect, useContext } from "react";
import "./App.css";
import getWindowDimensions from "./js/functions/getWinSizes.js";

import arrow from "./images/arrowup.svg";
import LeadForm from './LeadForm.jsx';
import WhatsAppIcon from './whatsapp/WhatsAppIcon';

import { Modal, Col, Row } from "react-bootstrap";

import { gsap } from "gsap";

import close from "./images/close.svg"

import {pricingData,
  returnFundsData,
  bannerData,
  howTo,
  whyWe,
  aboutUs,
  secondData,
  customersData,
  reliableData,
  footerData} from './Data.jsx'


function VerticalTicker({
  items = [],
  speed = 60, // px/sec
  gap = 12,
  className = "",
}) {
  const rootRef = useRef(null);
  const boxRefs = useRef([]);
  const tlRef = useRef(null);
  const roRef = useRef(null);

  const setBoxRef = (el, i) => {
    boxRefs.current[i] = el;
  };

  useLayoutEffect(() => {
    const root = rootRef.current;
    if (!root) return;

    const boxes = boxRefs.current.filter(Boolean);
    if (!boxes.length) return;

    // cleanup prev
    if (tlRef.current) tlRef.current.kill();
    tlRef.current = null;

    const setup = () => {
      // зупиняємо попередній tween перед новими вимірами
      if (tlRef.current) tlRef.current.kill();

      const heights = boxes.map((el) => Math.ceil(el.getBoundingClientRect().height));

      // offsets (stack)
      const offsets = [];
      let acc = 0;
      for (let i = 0; i < boxes.length; i++) {
        offsets[i] = acc;
        acc += heights[i] + gap;
      }

      const totalHeight = acc;
      const duration = totalHeight / speed;

      // контейнеру треба relative
      gsap.set(root, { position: "relative" });

      // ставимо кожен елемент в свою стартову позицію
      boxes.forEach((el, i) => {
        gsap.set(el, {
          y: offsets[i],
          willChange: "transform",
        });
      });

      const wrapY = gsap.utils.wrap(0, totalHeight);

      tlRef.current = gsap.to(boxes, {
        y: `-=${totalHeight}`,
        duration,
        ease: "none",
        repeat: -1,
        modifiers: {
          y: (y) => `${wrapY(parseFloat(y))}px`,
        },
      });
    };

    setup();

    // ResizeObserver на root + items
    const ro = new ResizeObserver(() => {
      // легкий debounce
      gsap.delayedCall(0.05, setup);
    });

    ro.observe(root);
    boxes.forEach((b) => ro.observe(b));
    roRef.current = ro;

    // на випадок пізніх шрифтів
    if (document.fonts?.ready) {
      document.fonts.ready.then(() => setup());
    }

    return () => {
      ro.disconnect();
      if (tlRef.current) tlRef.current.kill();
      tlRef.current = null;
    };
  }, [items, speed, gap]);

  return (
    <div ref={rootRef} className={`vertical-ticker ${className}`}>
      {items.map((item, i) => (
        <div
          key={i}
          ref={(el) => setBoxRef(el, i)}
          className="pricing-item vt-item"
        >
          <div className="pricing-item-icon" aria-hidden="true">
            ✓
          </div>
          <div className="pricing-item-body">
            {item.title ? <div className="pricing-item-title vt-title">{item.title}</div> : null}
            {item.text ? <div className="pricing-item-text vt-text">{item.text}</div> : null}
          </div>
        </div>
      ))}
    </div>
  );
}

const chunkArray = (arr, size) => {
  const result = [];
  for (let i = 0; i < arr.length; i += size) {
    result.push(arr.slice(i, i + size));
  }
  return result;
};

const renderPricingBlock = (data, id = "pricing") => {
  if (!data) return null;

  return (
    <>
    <section id={id} className="pricing-block">
      <div className="section-icon">
        <img src={data.icon} />
      </div>            
      <div className="pricing-inner">
        <div className="pricing-head">
          <h2 className="pricing-title">{data.title}</h2>
          {data.descr ? <p className="pricing-descr">{data.descr}</p> : null}

          <div className="pricing-badges">
            <span className="pricing-badge pricing-badge--ok">Без предоплаты</span>
            <span className="pricing-badge pricing-badge--ok">Оплата за результат</span>
            <span className="pricing-badge">Прозрачные условия</span>
          </div>
        </div>

        <div className="pricing-card">
          {data.list_title ? (
            <div className="pricing-list-title">{data.list_title}</div>
          ) : null}

          <VerticalTicker items={data.list} visibleRows={3} rowHeight={160} speed={15} />

          {data.afterText ? (
            <div className="pricing-footnote">
              <div className="pricing-footnote-icon" aria-hidden="true">ℹ</div>
              <div className="pricing-footnote-text">{data.afterText}</div> 
            </div>
          ) : null}
        </div>
      </div>
    </section>
    <section className="py-5 common__section contact-cta" id="contact-cta">
      <div className="section-icon">
        <img src={data.ctaIcon} />
      </div>        
      <div className="container">
        <div className="pricing-cta">
          <div className="pricing-cta-text">
            <h2>{data.ctaTitle}</h2>
            <p>{data.ctaDesc}</p>
<ul className="locations-list">
  { data.ctaAdresses.map(({country, city, address, icon}, index) => (
    <li key={index}><b>{country}, {city}</b>
    <p>{address}</p>
    <span className="location-icon"> 
      <img src={icon} />
    </span>
    </li>
  )) }
</ul>
<p>Мы сопровождаем клиентов независимо от их местоположения.
Большинство процессов проходит дистанционно — вы получаете результат без необходимости личного присутствия.</p>
          </div>
          <LeadForm />
        </div>
      </div>
    </section>
    </>
  );
};

const CommonContext = React.createContext({});

const ret = ({ onBackDropClick } = {}) => {
  const returnFunds = returnFundsData();
  return (
    <section
      className="common__section returnFunds"
      id="return-funds"      
    >
      {/* <img src={returnBg} alt="section background"/> */} 
      <div className="container">
        <div className="returnFunds__inner">
          <div className="returnFundsIMG">
            <img src={bitcoin} alt="" />
          </div>
          <div className="textBlock">
            <h3 className="my-4">{returnFunds.title}</h3>
            <p>{returnFunds.desc}</p>
            <p>{returnFunds.desc2}</p>
          </div>
        </div>
        <div className="banner-btn">
          <button
            className="btn-primary"
            onClick={() => {
              onBackDropClick();
            }}
          >
            {returnFunds.btn}
          </button>
        </div>
      </div>
    </section>
  );
};


const CustomModal = ({ onBackDropClick, children }) => {
  const [windowDimensions, setWindowDimensions] = useState(
    getWindowDimensions()
  );

  useEffect(() => {
    function handleResize() {
      setWindowDimensions(getWindowDimensions());
    }

    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);
  const wd = windowDimensions.width;
  const widthCon = () => {
    return wd > 1299 ? { width: "60%" } : { width: "100%" };
  };
  return (
    <div className="modalOverlay" onClick={onBackDropClick}>
      <div
        className="modalContainer"
        onClick={(e) => e.stopPropagation()}
        style={widthCon()}
      >
        <img className="closeForm" onClick={onBackDropClick} src={close} alt="close contact form" />
        {children}
      </div>
    </div>
  );
};


const ContactFormModal = ({ isModalVisible, onBackDropClick }) => {
  if (!isModalVisible) {
    return null;
  }

  return (
    <Modal onBackDropClick={onBackDropClick}>
      <div className="contactFormWrap">
        <div className="formTitle">
          <h2>Получить бесплатную консультацию</h2>
        </div>
        <LeadForm />
      </div>
    </Modal>
  );
};

const WhyWe = ({data, id}) => {
  return (
    <section
      className="whywe common__section"
      id={id}
    >
      <div className="section-icon">
        <img src={data.icon} />
      </div>            
      <div className="innerSection container">
        <div className="textBlock">
          {data.title ? <h2>{data.title}</h2> : null}
          {data.descr ? <p>{data.descr}</p> : null}
          {data.subdescr ? <p>{data.subdescr}</p> : null}
          {data.subdescr2 ? <p>{data.subdescr2}</p> : null}
        </div>       
        <div className="imageBlock">
          <img src={data.image} alt="why we image" />
        </div>
      </div>
    </section>
  );
};

const Testimonials = () => {
  const [indexTestimonials, setIndexTestimonials] = useState(0);

  const handleTestimonials = (selectedIndex, e) => {
    setIndexTestimonials(selectedIndex);
  };
  const renderTestimonials = customersData.list.map((e, i) => {
    return (
        <div className="slide-inner" key={i}>
          <Row>
            <Col xs="12" md="12" lg="2" className="user-avatar text-center">
              <img src={e.img} alt="tester avatar" className="tester-avatar" />
              <h5>{e.author}</h5>
            </Col>
            <Col
              xs="12"
              md="12"
              lg="10"
              className="align-self-center testimonial-content"
            >
              <p className="p-3">{e.text}</p>
            </Col>
          </Row>
        </div>
    );
  });
  return (
    <section
      className="tesimonials__external common__section"
      id="testimonials"
    >
      <div className="section-icon">
        <img src={customersData.icon} />
      </div>        
      <div className="container">
        <h3>{customersData.title}</h3>
        {customersData.desc !== "" ? <p className="descr">{customersData.desc}</p> : null}
        <div className="tesimonials__inner">
          {renderTestimonials}
        </div>
      </div>     
    </section>
  );
};

const Second = () => {
  const data = secondData();
  return (
    <section
      className="second common__section"
      id="second"      
    >
      <div className="section-icon">
        <img src={data.icon} />
      </div>         
      <div className="innerSection">
        <div className="rightBlock blocks">
          <h2>{data.titleRight}</h2>
          <p>{data.textRight}</p>
          <LeadForm />
        </div>
        <div className="leftBlock blocks"></div>
      </div>
    </section>
  );
};

const ReturnFunds = ({ onBackDropClick }) => {
  const returnFunds = returnFundsData();
  return (
    <section
      className="common__section returnFunds"
      id="return-funds"      
    >
      <div className="section-icon">
        <img src={returnFunds.icon} />
      </div>   
      <div className="container">
        <div className="returnFunds__inner">
          <div className="returnFundsIMG">
            <img src={bitcoin} alt="" />
          </div>
          <div className="textBlock">
            <h3 className="my-4">{returnFunds.title}</h3>
            <p>{returnFunds.desc}</p>
            <p>{returnFunds.desc2}</p>
          </div>
        </div>
        <div className="banner-btn">
          <button
            className="btn-primary"
            onClick={() => {
              onBackDropClick();
            }}
          >
            {returnFunds.btn}
          </button>
        </div>
      </div>
    </section>
  );
};

const Reliable = () => {
  const data = reliableData();
  return (<section className="reliable common__section" id="reliable">

    <div className="container">
      <h2>{data.title}</h2>
      <p className="descr">{data.descr}</p>
    </div>
  </section >);
}

const MenuInner = ({ openClose, burgerClick }) => {
  const classNameNav =()=> {
    return burgerClick === 1 ? "nav container show" : "nav container hidden";
  }
  return burgerClick !== 0 ? (
    <div className={classNameNav()} >
      <a href="#home" onClick={openClose} className="nav-link">Top</a>      
      <a href="#second" onClick={openClose} className="nav-link">Contact Us</a>       
      <a href="#whywe" onClick={openClose} className="nav-link">What We Can Do</a>
      <a href="#howToStart" onClick={openClose} className="nav-link">Start Steps</a> 
      <a href="#reliable" onClick={openClose} className="nav-link">Reliable Partner</a>
      <a href="#testimonials" onClick={openClose} className="nav-link">Reviews</a>
      <img src={close} alt="close menu" className="closeForm" onClick={openClose} />
    </div>
  ): null;
};

const Menu = ({toggleClick, burgerClick}) => {
  const classNameImg = () => {
    switch (burgerClick) {
      case 0:
        return "burgerImg";
      case 1:
        return "burgerImg rotate";
      case 2:
        return "burgerImg unrotate";
      default:
        return "burgerImg";
    }
  };
  return (
    <>
      <div
        className="menu"
        onClick={() => {
          toggleClick();
        }}
      >
        <img src={burger} alt="burger" className={classNameImg()} />
      </div>
      <MenuInner burgerClick={burgerClick} openClose={toggleClick} />
    </>
  );
};

const HowToStart = ({ data, widthItem }) => {
  const global = useContext(CommonContext);

  return (
    <section
      className="howToStart common__section"
      id="howToStart"     
    >
      <div className="section-icon">
        <img src={data.icon} />
      </div>      
      <div className="container">
        <div className="leftBlock">
          <h2>{data.title}</h2>
          <p>{data.descr}</p>
        </div>
        <div className="rightBlock">
          <ul className="list">
            {data.list.map((e, i) => (
              <li key={i}>
                <div className="firstL">
                  <div className="secondL">
                    <h3>{e.title}</h3>
                    <p>{e.text}</p>
                  </div>
                </div>
              </li>
            ))}
          </ul>  
          <p>{data.afterText}</p>     
        </div>
      </div>
    </section>
  );
};

const Benefits = () => {
  const data = whyWe();

  return (
    <section
      className="benefits common__section"
      id="benefits"     
    >
      <div className="section-icon">
        <img src={data.icon} />
      </div>         
      <div className="innerSection container">
        <div className="imageBlock">
          <h4>{data.cFtitle}</h4>
          <LeadForm />
        </div>
        <div className="textBlock">
          <h2>{data.title}</h2>
          <ul className="list">
            {data.list.map((e, i) => (
              <li key={i} >
                <span className="numbers">{`${i + 1}`}</span>
                <span>{e.text}</span>
              </li>
            ))}
          </ul>
        </div>
      </div>
    </section>
  );
};

const Banner = () => {
  const data = bannerData();

  return (
    <section className="banner" id="home">
      <div className="section-icon">
        <img src={data.icon} />
      </div>
      <div className="bannerInner">
        <div className="container">
          <div className="gridBanner">
            <div className="leftBlock block">
              <div className="bannerLogo">
                <img src={data.logo} alt="logo" />
              </div>
              <div className="bannerText">
                <h1>{data.title}</h1>
                <h2>{data.firstBlock}</h2>
                {data.secondBlock ? (
                  <p className="banner-descr">{data.secondBlock}</p>
                ) : null}
              </div>
            </div>
            <div className="rightBlock block">
              <h3>{data.cFtitle}</h3>
              <p>{data.cFtext}</p>
              <LeadForm />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

function Footer() {
  const data = footerData();

  const openModal = (key) => {
    // Вариант 1: Bootstrap modal через глобальные функции
    if (key === "privacyModal" && window.openPrivacyModal) setShowPrivacy(true);
    if (key === "termsModal" && window.openTermsModal) setShowTerms(true);

    // Вариант 2: если у тебя модалки по id (bootstrap 5)
    // window.bootstrap?.Modal?.getOrCreateInstance(document.getElementById('privacyModal'))?.show();
  };

  return (
    <footer className="site-footer">
      <div className="footer-inner">
        <div className="footer-top">
          <div className="footer-brand">
            <div className="footer-logo">
              <img src={data.brand.logo} alt={data.brand.alt} />
            </div>

            <p className="footer-tagline">{data.brand.tagline}</p>

            <div className="footer-trust">
              {data.brand.trust.map((t, i) => (
                <div className="trust-item" key={i}>
                  <span className="trust-icon" aria-hidden="true">✓</span>
                  <span>{t}</span>
                </div>
              ))}
            </div>
          </div>

          <div className="footer-columns">
            {data.columns.map((col, idx) => (
              <div className="footer-col" key={idx}>
                <div className="footer-col-title">{col.title}</div>

                {col.type === "links" ? (
                  <ul className="footer-links">
                    {col.items.map((it, i) => (
                      <li key={i}>
                        <a href={it.href}>{it.label}</a>
                      </li>
                    ))}
                  </ul>
                ) : null}

                {col.type === "list" ? (
                  <ul className="footer-list">
                    {col.items.map((it, i) => (
                      <li key={i}>{it.label}</li>
                    ))}
                  </ul>
                ) : null}

                {col.type === "legal" ? (
                  <>
                    <ul className="footer-links">
                      {col.items.map((it, i) => (
                        <li key={i}>
                          {it.action ? (
                            <button
                              type="button"
                              className="footer-link-btn"
                              onClick={() => openModal(it.action)}
                            >
                              {it.label}
                            </button>
                          ) : (
                            <a href={it.href}>{it.label}</a>
                          )}
                        </li>
                      ))}
                    </ul>

                    <div className="footer-note">
                      <div className="footer-note-title">{col.noteTitle}</div>
                      <p>{col.noteText}</p>
                    </div>
                  </>
                ) : null}
              </div>
            ))}
          </div>
        </div>

        <div className="footer-divider" />

        <div className="footer-bottom">
          <div className="footer-bottom-left">
            {data.bottom.mini.map((m, i) => (
              <div className="footer-mini" key={i}>
                <span className="footer-mini-label">{m.label}</span>
                <span>{m.text}</span>
              </div>
            ))}
          </div>

          <div className="footer-bottom-right">
            <div className="footer-copy">
              {data.bottom.copyright.replace("{year}", new Date().getFullYear())}
            </div>

            <div className="footer-badges">
              {data.bottom.badges.map((b, i) => (
                <span className="footer-badge" key={i}>
                  {b}
                </span>
              ))}
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}

const App = () => {
  const [isModalVisible, setModalVisible] = useState(false);
  const toggleModal = () => {
    setModalVisible((wasModalVisible) => !wasModalVisible);
  };
  const [windowDimensions, setWindowDimensions] = useState(
    getWindowDimensions()
  );

  useEffect(() => {
    function handleResize() {
      setWindowDimensions(getWindowDimensions());
      //setModalVisible(false);
    }

    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);
  const wd = windowDimensions.width;
  const hd = windowDimensions.height;
  const global = {
    wd: wd,
    hd: hd,
  };

  const topRef = useRef();
  function handleBackClick() {
    topRef.current.scrollIntoView({ behavior: "smooth" });
  }
  const [show, doShow] = useState("hidden");
  useLayoutEffect(() => {
    const onScroll = () => {
      const scrollPos = window.scrollY;      
      if (scrollPos > 100) {
        doShow("visible");
      } else {
        doShow("hidden");
      }
    };

    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);
  return (
    <>
      <div className="App" ref={topRef}>
        <Banner  />
        <HowToStart
          data={howTo()}
          widthItem={32}
        /> 
        <Benefits  />
        <HowToStart
          
          data={returnFundsData()}
          widthItem={48}
        />
        <WhyWe data={aboutUs} id="about" />         
        <Testimonials />
        <div className={`toTopButton ${show}`} onClick={handleBackClick}>
          <img src={arrow} alt="" />
        </div>
        <ContactFormModal
          isModalVisible={isModalVisible}
          onBackDropClick={toggleModal}
        />
        { renderPricingBlock(pricingData()) }
        { Footer() }
      </div>
      <WhatsAppIcon />
    </>
  );
};

export default App;